import Interface from "@/util/interface"
import {formatTimeToStr} from "@/util/date"
import {uploads} from '@/util/upload'

export default {
    data() {
        return {
            comment: [],
            comment_text: "",
            showActionMeme: false,
        }
    },
    methods: {
        getComment() {
            let _this = this
            if (_this.comment.length > 0) {
                let comment = _this.comment[_this.comment.length-1].comment
                _this.last_comment_id = comment[comment.length-1].id
            }
            let params = {
                content_id: this.id,
                comment_type: 4,
                page: 1,
                pageSize: 9999,
                id: this.last_comment_id,
            }
            Interface.getData('get', Interface.course.comment.list, params).then((res) => {

                if (res.code === 0 && res.data.list != null) {
                    let comment = JSON.parse(JSON.stringify(this.comment))

                    for (let i = (res.data.list.length - 1); i >= 0; i--) {

                        let val = res.data.list[i]

                        //直播小助手发言
                        let manager = this.in_array(val.avatar, this.live_manager_avatar) ? 1 : 0

                        //当前用户被@
                        if (val.subscribe && val.subscribe.user_id === this.user.id) {
                            val.content = val.content.replace("@" + val.subscribe.nickname, "<span style='background-color: #FFBD3F'>@" + val.subscribe.nickname + "</span>")
                        }

                        //当前是否被引用
                        let cite_content = ""
                        if (val.cite != null) {
                            cite_content = val.cite.nickname + " : " +val.cite.content.replace(/\\x(\d{1,2})/g, "<img src=\"http://static.mudu.tv/assets/img-console/activity/face/$1.png\" />")
                        }

                        let content = {
                            id: val.id,
                            avatar: val.avatar,
                            nickname: val.nickname,
                            message: val.content,
                            manager: manager,
                            user_id: val.user_id,
                            cite_content: cite_content,
                        }

                        //如果是第一条信息
                        if (comment.length === 0) {
                            comment.push({key: val.dateline, comment: [content]})
                            continue;
                        }

                        let has_dateline = false
                        for (let index = 0; index < comment.length; index++) {
                            if (comment[index].key === val.dateline) {
                                comment[index].comment.push(content)
                                has_dateline = true
                                break
                            }
                        }

                        if (!has_dateline) {
                            comment.push({key: val.dateline, comment: [content]})
                        }
                    }
                    this.comment = comment
                    this.scrollEnd()
                }
            })
        },
        createComment(f) {
            let _this = this

            if(f == 'live'){
              console.log(_this.checkLiveAuth(_this))
                if (_this.checkLiveAuth(_this) !== 'ok'){
                    return
                }
            }else{
                if(!_this.checkLogin){
                    if (!Interface.checkComplete(this)){
                        return;
                    }
                }
            }

            let name = _this.user.nick_name
            this.showActionMeme = false

            if (this.busy) {
                return
            }
            if (this.comment_text === "") {
                return;
            }

            let params = {
                content_id: this.id,
                comment_type: 4,
                content: this.comment_text,
            }
            if (this.subscribe) {
                params.subscribe_id = this.subscribe.id
            }
            let cite_content = ""
            if (this.cite) {
                params.cite_id = this.cite.id
                cite_content = this.cite.nickname + " : " +this.cite.message.replace(/\\x(\d{1,2})/g, "<img src=\"http://static.mudu.tv/assets/img-console/activity/face/$1.png\" />")
            }

            this.busy = true
            Interface.getData('post', Interface.comment, params).then((res) => {
                this.busy = false

                if (res.code === 0) {

                    let time = new Date().getTime()
                    let manager = _this.in_array(this.user.avatar, this.live_manager_avatar) ? 1 : 0
                    let dateline = formatTimeToStr(time, "MM月dd日 hh:mm")

                    let content = {
                        id: res.data.id,
                        avatar: this.user.avatar,
                        nickname: name,
                        message: this.comment_text,
                        manager: manager,
                        user_id: this.user.id,
                        cite_content: cite_content,
                        dateline: time / 1000
                    }

                    if (this.comment.length === 0) {
                        this.comment.push({key: dateline, comment: [content]})
                    } else {
                        let has_dateline = false
                        for (let index = 0; index < this.comment.length; index++) {
                            if (this.comment[index].key === dateline) {
                                this.comment[index].comment.push(content)
                                has_dateline = true
                                break
                            }
                        }

                        if (!has_dateline) {
                            this.comment.push({key: dateline, comment: [content]})
                        }
                    }
                    _this.scrollEnd()
                    this.comment_text = ""
                    this.cite = null
                    this.subscribe = null
                }
            })
            if (this.live.live_status < 2) {
                window.Mudu.Room.Comment.Send(
                    // 要发送的评论文本，类型为string
                    _this.comment_text,
                    function (response) {
                        if (response.status === 'y') {
                            console.log('发送成功，成功码为：' + response.flag)
                        }
                        if (response.status === 'n') {
                            console.log('发送失败，错误码为：' + response.flag)
                        }
                    }
                )
            }
        },
        choose_meme(index) {
            this.comment_text += index < 10 ? '\\x' + index : '\\x' + index
            if(this.live.id == 727){
                this.createComment()
            }
        },
        uploadCommentImg(result) {
            uploads(result, function (res) {
            }).then(res => {
                if (res.code === 0) {
                    this.comment_text = "<img style='width: inherit;height: inherit;max-width: 245px;margin: -12px -11px' src='" + res.data.url + "'>";
                }
            })
        },
        longTouch(i, pi) {
            if (this.is_manager === 1) {
                this.comment[pi].comment[i].showBtn = !(this.comment[pi].comment[i].showBtn)
                this.$forceUpdate()
            }
        },
        subscribeUser(i, pi) {
            this.subscribe = this.comment[pi].comment[i]
            this.comment[pi].comment[i].showBtn = false
            this.comment_text = "@" + this.subscribe.nickname + " " + this.comment_text
            this.$forceUpdate()
        },
        subscribeAndCite(i, pi) {
            this.subscribe = this.comment[pi].comment[i]
            this.cite = this.comment[pi].comment[i]
            this.comment[pi].comment[i].showBtn = false
            this.comment_text = "@" + this.subscribe.nickname + " " + this.comment_text
            this.$forceUpdate()
        },
        deleteMessage(i, pi) {
            if (this.is_manager === 1) {
                Interface.getData('delete', Interface.comment + "/" + this.comment[pi].comment[i].id).then((res) => {
                    if (res.code === 0) {
                        this.comment[pi].comment.splice(i, 1)
                        this.$toast.success("删除成功")
                    }
                })
            }
        },
    }
}



// WEBPACK FOOTER //
// ./src/mixins/comment.js